<template>
  <div class="toolbar-wrapper">
    <div class="container">
      <div class="row">
        <div class="col">
          <ul>
            <li>
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover title="Undo (⌘+z)" variant="clear" disabled>
                  <i class="fa fa-undo" aria-hidden="true"></i>
                  </b-button>
                <b-button placement="bottom" v-b-tooltip.hover title="Redo (⌘+shift+z)" variant="clear" disabled>
                  <i class="fa fa-redo" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>
            <li v-if="flags.addTextButton">
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover title="Duplicate Text" variant="clear" :disabled="true">
                  <i class="fa fa-clone" aria-hidden="true"></i>
                </b-button>
                <b-button variant="clear" v-b-tooltip.hover title="Delete Object" :disabled="true">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>
            <li>
              <EditModeToggle disabled @onTextMode="emit('onTextMode')"></EditModeToggle>
            </li>
            <li>
              <ul class="list-group">
                <li class="item fonts">
                  <b-dropdown disabled variant="clear" :text="canvasState.fontName" class="m-md-2" id="font-dropdown" :style="{fontFamily:canvasState.fontName}" v-b-tooltip.hover title="Click on active text to view font family">
                    <b-dropdown-item v-for="font in canvasState.fonts" :key='font' :style="{fontFamily:font}">{{font}}</b-dropdown-item>
                  </b-dropdown>
                </li>
                <li class="item" >
                  <div class="font-size-wrapper dropdown-menu-right">
                    <input disabled type="text" size="6" :value="canvasState.fontSize" name="currentFontSize" v-b-tooltip.hover title="Click on active text to view font size">
                  </div>
                </li>
                <li class="item">
                  <b-dropdown disabled variant="clear" size="lg">
                    <template slot="button-content">
                      <i class="current color-square" aria-hidden="true" :style="`background-color: ${canvasState.color};`"></i>
                    </template>
                    <b-dropdown-header>Document Colors</b-dropdown-header>
                    <b-dropdown-item v-for="color of canvasState.colors" :key="color">
                      <button class="dropdown-item color-square" :style="`background-color: ${color};`"></button> <!--ANGULAR: *ngFor="let color of row" [style.background]="'rgb('+color.rgb+')'" (click)="onColor.emit(color.rgb)"-->
                    </b-dropdown-item>
                  </b-dropdown>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import EditModeToggle from '../editor/EditModeToggle'
import {mapGetters} from 'vuex';

export default {
  components: {EditModeToggle},
  computed: {
    ...mapGetters(['flags']),
    canvasState() {
      return {};
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

  @import '~scss/abstracts/_variables';
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import '~bootstrap/scss/mixins/_breakpoints';
  @import '~scss/colors';

  .spacer{
   height: 60px;
   background-color:  $gray-3;  }

  :host {
    position: relative;
  }

  .toolbar-wrapper {
    height: 50px;
    width: 100%;
    background-color: $gray-3;
    position:fixed;
    top: $navbar-height;
    z-index: 5;
    color: get-theme-color('primary', 'dark');
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);

    @include media-breakpoint-up(sm) {
      left: 0;
      //left: 90px;
    }

    @include media-breakpoint-only(xs) {
      left: 0;
      //left: 80px;
    }

    ul {
      list-style-type: none;
      display: inline-table
    }

    li {
      display: table-cell;
      line-height: 50px;
      padding: 0 15px;

      &.item {
        cursor: pointer;

        .color-picker {
          i {
            display: inline-block;
            font-size: 1.33333333em;
            line-height: 0.75em;
            border-radius: 5px;
            width: 25px;
            height: 25px;
            vertical-align: middle;
            box-shadow: inset 1px 1px 6px rgba(0, 0, 0, .15), inset -1px -1px 0 rgba(255, 255, 255, .25);
            border: none !important;
          }
        }

      }

      &.active {
        background: get-theme-color('primary', 'dark');
        color: $gray-3;
      }
    }

    // .list-group {
    // }

    .dropdown-menu {
      max-height: 300px;
      overflow-y: scroll;
    }

    .dropdown-menu-font-sizes {
      min-width: 80px;

      button {
        line-height: normal;
        height: 30px;
      }
    }

    .color-row {
      margin: 0;
      padding: 0;
      height: 40px;

      &:first-child {
        .color-square:first-child {
          border-top-left-radius: 4px;
        }

        .color-square:last-child {
          border-top-right-radius: 5px;
        }
      }

      &:last-child {
        .color-square:first-child {
          border-bottom-left-radius: 4px;
        }

        .color-square:last-child {
          border-bottom-right-radius: 5px;
        }
      }

    }

    .color-square {
      width: 40px;
      height: 40px;
      box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .05), inset -1px -1px 0 rgba(0, 0, 0, .05);
      border: none !important;
      display: inline-block;

      &.current {
        width: 16px;
        height: 16px;
        // For some reason the content is 20px high. This fixes it
        margin-bottom: -4px;
      }

      &:hover {
        opacity: 0.5;
        filter: alpha(opacity=50);
      }
    }

    .font-size-wrapper {
      input {
        padding: 7px;
        font-size: 14px;
        width: 3.5em;
      }
      &:after {
        position: relative;
        margin: 0;
        left: -17px;
      }
    }

    a[disabled] {
      color: #aaa;
    }

  }

</style>
<style lang="scss">
.toolbar-wrapper {
  .btn-clear {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 8px 15px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/upload/PseudoToolBar.vue